import { Pipe, PipeTransform } from "@angular/core";
import { TopicTagInterface } from "@core/interfaces/forums/topic.interface";
import { UtilsService } from "@core/services/utils/utils.service";

/**
 * Generates border colors for topic tags based on their category and subcategory
 *
 * The colors are deterministic (same category+subcategory always produces the same color)
 * and are designed to provide soft, pastel-like borders with enough contrast
 * for visibility while fitting into the dark UI theme.
 */
@Pipe({ name: "tagBorderColor", pure: true })
export class TagBorderColorPipe implements PipeTransform {
  transform(tag: TopicTagInterface): string {
    if (!tag || !tag.category) {
      return "hsla(210, 30%, 50%, 0.5)"; // Default to a muted blue
    }

    const hashString = tag.subcategory ? `${tag.category}-${tag.subcategory}` : tag.category;
    const hash = UtilsService.stringToHash(hashString.toLowerCase());

    const hue = hash % 360;
    const saturation = 25 + (hash % 10); // 25-35% - More muted saturation
    const lightness = 40 + (hash % 10); // 40-50% - Medium lightness for visibility

    return `hsla(${hue}, ${saturation}%, ${lightness}%, 0.5)`; // Moderate opacity
  }
}
